import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import useStore from '../hooks/useStore'
import Topbar from '../components/Topbar'
import Sidebar from '../components/Sidebar'
import FundamentalsPanel from '../components/FundamentalsPanel'
import MonthlyPanel from '../components/MonthlyPanel'
import MorningPanel from '../components/MorningPanel'
import FocusPanel from '../components/FocusPanel'
import ScorePanel from '../components/ScorePanel'
import HistoryPanel from '../components/HistoryPanel'
import CanvasPanel from '../components/CanvasPanel'
import CommunityPanel from '../components/CommunityPanel'
import FeedbackPanel from '../components/FeedbackPanel'
import Toast from '../components/Toast'
import TipsPanel from '../components/TipsPanel'

function Dashboard() {
  const { user, loadHistory, loadMonthlyGoal, loadTodayLoop, loadBurningDesire, currentPanel } = useStore()

  useEffect(() => {
    if (user) {
      Promise.all([
        loadHistory(),
        loadMonthlyGoal(),
        loadTodayLoop(),
        loadBurningDesire(),
      ]).catch(error => {
        console.error('Failed to load dashboard data:', error)
      })
    }
  }, [user, loadHistory, loadMonthlyGoal, loadTodayLoop, loadBurningDesire])

  if (!user) {
    return null // This shouldn't happen due to routing, but safety check
  }

  return (
    <>
      <div className="ambient">
        <div className="orb orb1"></div>
        <div className="orb orb2"></div>
        <div className="orb orb3"></div>
      </div>
      <div className="app-shell">
        <Topbar />
        <Sidebar />
        <main className="main">
          <Routes>
            <Route path="/" element={<MonthlyPanel />} />
            <Route path="/canvas" element={<CanvasPanel />} />
            <Route path="/fundamentals" element={<FundamentalsPanel />} />
            <Route path="/monthly" element={<MonthlyPanel />} />
            <Route path="/morning" element={<MorningPanel />} />
            <Route path="/focus" element={<FocusPanel />} />
            <Route path="/score" element={<ScorePanel />} />
            <Route path="/history" element={<HistoryPanel />} />
            <Route path="/community-live" element={<CommunityPanel />} />
            <Route path="/feedback" element={<FeedbackPanel />} />
          </Routes>
        </main>
      </div>
      <Toast />
      <TipsPanel />
    </>
  )
}

export default Dashboard
